import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";
import { IonIcon } from "@ionic/react"; // Add this import
export const ionicButtonVariants = cva('text-white rounded-md leading-[100%] overflow-hidden', {
    variants: {
        variant: {
            default: 'bg-primary hover:bg-hover-primary',
            secondary: 'bg-secondary hover:bg-hover-secondary',
            ghost: 'bg-transparent text-primary hover:opacity-50',
            outline: 'bg-transparent border text-text-dark-high dark:text-text-light-high hover:opacity-70',
            lite: 'bg-[#F5FBFF] dark:bg-surface-secondary border text-primary dark:text-white hover:bg-customs-blue'
        },
        size: {
            xs: 'h-8 px-3 text-xs',
            sm: 'h-9 px-3 text-sm',
            default: 'h-10 px-4 text-sm',
            lg: 'h-11 px-4 text-base',
            xlg: 'h-12 px-6 text-base'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default'
    }
});
export const IonicButton = ({ children, disabled, variant, size, icon, iconPosition, iconIos, iconMd, className, ...rest })=>{
    // Determine the icon slot based on iconPosition
    let iconSlot;
    if (iconPosition === 'start') {
        iconSlot = 'start';
    } else if (iconPosition === 'end') {
        iconSlot = 'end';
    } else if (iconPosition === 'only') {
        iconSlot = 'icon-only';
    } else if ((icon || iconIos || iconMd) && !children) {
        // If we have an icon but no children, assume icon-only
        iconSlot = 'icon-only';
    } else if ((icon || iconIos || iconMd) && children) {
        // Default icon position is start when there's also text
        iconSlot = 'start';
    }
    return /*#__PURE__*/ _jsxs("button", {
        disabled: disabled,
        className: cn(ionicButtonVariants({
            variant,
            size
        }), `${disabled ? 'cursor-not-allowed opacity-50 pointer-events-none' : 'opacity-100'}`, className),
        ...rest,
        children: [
            (icon || iconIos || iconMd) && iconPosition !== 'end' && /*#__PURE__*/ _jsx(IonIcon, {
                slot: iconSlot,
                icon: icon,
                ios: iconIos,
                md: iconMd
            }),
            iconSlot !== 'icon-only' && children,
            (icon || iconIos || iconMd) && iconPosition === 'end' && /*#__PURE__*/ _jsx(IonIcon, {
                slot: iconSlot,
                icon: icon,
                ios: iconIos,
                md: iconMd
            })
        ]
    });
};
export default IonicButton;

//# sourceMappingURL=Button.js.map